import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker DISABLED (Oct 2026): the old PWA worker cached HTML/JS and
// pinned returning visitors to stale builds. /service-worker.js is now a
// kill-switch that old clients still fetch once — it wipes caches and
// unregisters itself. Do not re-register without a versioned strategy.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((regs) => regs.forEach((r) => r.update()))
      .catch(() => {});
  });
}
